import ArchiveIcon from '../../../../../icons/delete.svg'
import EmailIcon from '../../../../../icons/email.svg'
import RestoreIcon from '../../../../../icons/restore.svg'
import UploadIcon from '../../../../../icons/upload-1.svg'
import ApplicantIcon from '../../../../../icons/user.svg'
import ViewingIcon from '../../../../../icons/viewing.svg'

export const LISTING_PROFILE_HEADER_FOOTER_ACTION = {
  addApplicant: 'addApplicant',
  bookViewing: 'bookViewing',
  emailApplicant: 'emailApplicant',
  uploadDocument: 'uploadDocument',
}

export const LISTING_PROFILE_HEADER_FOOTER_ACTION_TEXT_KEY = {
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.addApplicant]:
    'RentalPortal.ListingProfileFooterAddApplicantBtnKey',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.bookViewing]:
    'RentalPortal.ListingProfileFooterBookViewingBtnKey',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.emailApplicant]:
    'RentalPortal.ListingProfileFooterEmailApplicantBtnKey',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.uploadDocument]:
    'RentalPortal.ListingProfileFooterUploadDocumentBtnKey',
}

export const LISTING_PROFILE_HEADER_FOOTER_ACTION_QA_NAME = {
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.addApplicant]:
    'listingProfileHeaderActionAddApplicant',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.bookViewing]:
    'listingProfileHeaderActionBookViewing',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.emailApplicant]:
    'listingProfileHeaderActionEmailApplicant',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.uploadDocument]:
    'listingProfileHeaderActionUploadDocument',
}

export const QA_NAME_LISTING_PROFILE_HEADER_FOOTER_ADD_NEW =
  'listingProfileHeaderAddNewText'

export const QA_NAME_LISTING_PROFILE_HEADER_FOOTER_PRIMARY_ACTION =
  'listingProfileHeaderActionPrimary'

export const QA_NAME_LISTING_PROFILE_HEADER_FOOTER_MORE =
  'listingProfileHeaderActionMore'

export const LISTING_PROFILE_HEADER_FOOTER_ACTION_PERMISSION_NAME = {
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.addApplicant]: 'can_view_applicants',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.bookViewing]: 'can_view_viewings',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.emailApplicant]: 'can_view_applicants',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.uploadDocument]: 'can_view_documents',
}

export const LISTING_PROFILE_HEADER_FOOTER_ACTION_UNAVAILABLE_TOOLTIP_KEY = {
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.addApplicant]:
    'RentalPortal.ListingProfileFooterAddApplicantUnavailableTooltipKey',
  [LISTING_PROFILE_HEADER_FOOTER_ACTION.emailApplicant]:
    'RentalPortal.ListingProfileFooterEmailApplicantUnavailableTooltipKey',
}

export const LISTING_PROFILE_HEADER_FOOTER_ACTION_ITEMS = [
  {
    Icon: ApplicantIcon,
    action: LISTING_PROFILE_HEADER_FOOTER_ACTION.addApplicant,
  },
  {
    Icon: UploadIcon,
    action: LISTING_PROFILE_HEADER_FOOTER_ACTION.uploadDocument,
  },
  {
    Icon: EmailIcon,
    action: LISTING_PROFILE_HEADER_FOOTER_ACTION.emailApplicant,
  },
  {
    Icon: ViewingIcon,
    action: LISTING_PROFILE_HEADER_FOOTER_ACTION.bookViewing,
  },
]

export const LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION = {
  archive: 'archive',
  restore: 'restore',
}

export const LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_ICON = {
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.archive]: ArchiveIcon,
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.restore]: RestoreIcon,
}

export const LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_TEXT_KEY = {
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.archive]:
    'RentalPortal.ListingArchiveBtnKey',
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.restore]:
    'RentalPortal.ListingRestoreBtnKey',
}

export const LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_QA_NAME = {
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.archive]:
    'listingProfileHeaderActionArchive',
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.restore]:
    'listingProfileHeaderActionRestore',
}

export const LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME = {
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.archive]: 'can_archive',
  [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.restore]: 'can_restore',
}
